import { REGEX_PATTERNS } from '@constants';
import * as yup from 'yup';

const validationSchema = yup.object({
  internalId: yup
    .string()
    .required('Required')
    .matches(REGEX_PATTERNS.Numbers, 'Internal ID should only contain numbers'),
  spName: yup.string().required('Required'),
  contactFullName: yup
    .string()
    .required('Required')
    .matches(
      REGEX_PATTERNS.Letters,
      'Contact Full Name should only contain letters'
    ),
  email: yup
    .string()
    .required('Required')
    .matches(REGEX_PATTERNS.Email, 'Enter a valid email'),
  contactRole: yup.string().required('Required'),
  telephone: yup
    .string()
    .required('Required')
    .matches(
      REGEX_PATTERNS.Phone,
      'Telephone should follow the E.164 format, e.g. +30xxxxxxxxxx'
    ),
});

export default validationSchema;
